import { MyOffers } from '@sorare/marketplace/src/components/mySorare/MyOffers';
import { MySorarePage } from '@sorare/marketplace/src/components/mySorare/common/pages';

const Page = () => {
  return <MyOffers page={MySorarePage.OFFERS_RECEIVED} />;
};
export default Page;
